module.exports = __webpack_public_path__ + "img/2-31-4.aaacc124.png";